import { MfaRequestModel } from 'models/auth';
import axiosClient, { handleRequest } from './axiosClient';
import { HttpResponse } from 'models';
import { MfaQrResponseModel } from 'models/mfa';
import { getLocalStorage } from 'utils/sessionStorage';

const mfaApi = {
  create: (body: MfaRequestModel) => {
    const url = `/terabet/api/mfa/create`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  get: (): Promise<HttpResponse<MfaQrResponseModel>> => {
    const url = `/terabet/api/mfa/get`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  disable: (body: MfaRequestModel) => {
    const url = `/terabet/api/mfa/disable`;
    return handleRequest(
      axiosClient.post(url, body, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
};

export default mfaApi;
